import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export const mainLinks = [
  { to: "/", label: "Home", id: "nav-home-link" },
];

const contactLink = { to: "/contact", label: "Contact Us", id: "nav-contact-link" };

const linkClass = ({ isActive }) =>
  `relative px-1 py-1 text-sm transition-colors duration-200 ${isActive ? "text-body" : "text-muted hover:text-body"}`;

const DesktopLink = ({ l }) => (
  <NavLink to={l.to} end={l.to === "/"} className={linkClass} data-testid={l.id}>
    {({ isActive }) => (
      <>
        {l.label}
        {isActive && (
          <motion.span layoutId="nav-dot" className="absolute -bottom-[3px] left-1/2 h-[3px] w-[3px] -translate-x-1/2 rounded-full bg-blue" />
        )}
      </>
    )}
  </NavLink>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  const allMobile = [...mainLinks, contactLink];

  return (
    <header className="sticky top-0 z-50 border-b border-line/70 bg-ink/75 backdrop-blur-xl" data-testid="site-header">
      <div className="flex h-16 w-full items-center justify-between px-4 sm:px-6">
        <Link to="/" className="flex items-center" data-testid="header-logo-link" onClick={() => setOpen(false)}>
          <img src="/x-mark.png" alt="X" className="h-8 w-auto object-contain" height={32} />
          <span className="-ml-1 text-[19px] font-semibold tracking-tight text-body">pattern</span>
        </Link>

        <nav className="hidden items-center gap-8 md:flex" data-testid="header-nav">
          {mainLinks.map((l) => <DesktopLink key={l.to} l={l} />)}
          <DesktopLink l={contactLink} />
        </nav>

        <button
          type="button"
          aria-label="Toggle menu"
          className="flex h-9 w-9 items-center justify-center rounded-full border border-line text-body md:hidden"
          onClick={() => setOpen((v) => !v)}
          data-testid="header-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden border-t border-line/70 bg-ink/95 md:hidden"
            data-testid="mobile-nav"
          >
            <div className="flex flex-col px-5 py-3">
              {allMobile.map((l) => (
                <NavLink
                  key={l.to}
                  to={l.to}
                  end={l.to === "/"}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `py-3 text-base ${isActive ? "text-blue-text" : "text-body"}`}
                  data-testid={`mobile-${l.id}`}
                >
                  {l.label}
                </NavLink>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
